import axios from "axios";
import setupInterceptorsTo from "./AxiosInterceptor";


// const BASE_URL = process.env.REACT_APP_LOCAL_URL;
setupInterceptorsTo(axios);

export const handleResponse = (response) => {
  return { ...response.data, status: 1, };
};

export const handleError = (error) => {
  return { status: 0, error: error?.message || 'Something went wrong' };
};

const api = {

  login: {
    clientLogin: (data) => {
      return axios.post('https://www.grcpulse.in/api/companyMasterProfile/login', data);
    },
    adminLogin: (data) => {
      return axios.post('https://www.grcpulse.in/api/admin/AdminLogin', data);
    },
    assessorLogin: (data) => {
      return axios.post('https://www.grcpulse.in/api/Assessor/assessor-login', data);
    },
    vendorLogin: (data) => {
      return axios.post('https://www.grcpulse.in/api/vendorMasterProfile/login', data);
    },
    CorporateLogin: (data) => {
      return axios.post('https://www.grcpulse.in/api/central/CorporateLogin', data)
    },
   
  },
  forgotPassword: {

    forgotPasswsord: (data) => {
      return axios.post(`https://www.grcpulse.in/api/vendorMasterProfile/forgot-password`, data)

    },
    verifyOTP: (data) => {
      return axios.post(`https://www.grcpulse.in/api/vendorMasterProfile/verify-otp`, data)

    },
    resetPassword: (data) => {
      return axios.post(`https://www.grcpulse.in/api/vendorMasterProfile/reset-password`, data)

    }

  },

  masterData: {
    createMasterData: (data) => {
      return axios.post(`https://www.grcpulse.in/api/companyMasterData/newMasterData`, data);
    },
  

    getClientMasterData: (id) => {
      return axios.get(`https://www.grcpulse.in/api/companyMasterData/clientMasterData/${id ? id : 'id'}`)
    },
    getVendorMasterData: (id) => {
      return axios.get(`https://www.grcpulse.in/api/companyMasterData/vendorDetails/${id ? id : 'id'}`);
    },
    updateMasterData: (data) => {
      return axios.put(`https://www.grcpulse.in/api/companyMasterData/updateMasterData`, data);
    }

  },

  client: {
    getByCategory: (id,category) => {
return axios.get(`https://www.grcpulse.in/api/ClientsMaterData/getbycategory/${id ? id : 'id'}`, { params: { Category: category } })
    },
 verifyOTPEST: (data) => {
      return axios.post(`https://www.grcpulse.in/api/companyMasterProfile/verify-otp`,data)

    },
    resendOTP: (data) => {
        return axios.post(`https://www.grcpulse.in/api/companyMasterProfile/resendOtp`,data)
    },
    getClient: (id) => {
      return axios.get(`https://www.grcpulse.in/api/companyMasterProfile/findOne/${id ? id : 'id'}`);
    },
    editClient: (id, data) => {
      return axios.put(`https://www.grcpulse.in/api/companyMasterProfile/updateOne/${id ? id : 'id'}`, data);
    },
    createClient: (data) => {
      return axios.post(`https://www.grcpulse.in/api/companyMasterProfile/newCompanyProfile`, data);
    },
    getClients: () => {
      return axios.get(`https://www.grcpulse.in/api/companyMasterProfile/comapanyNames`);
    },
    getAllVendors: (id, data) => {
      return axios.get(`https://www.grcpulse.in/api/companyMasterProfile/getallvendors/${id ? id : 'id'}`, data);
    },
    getAvgDataVendors: (id, year) => {
      return axios.get(`https://www.grcpulse.in/api/companyMasterProfile/allvendors-monthly-data/${id ? id : 'id'}`, { params: { year } });
    },
    getLcrReport: (id, data) => {
      return axios.get(`https://www.grcpulse.in/api/companyMasterProfile/getallvendors/${id ? id : 'id'}`, data);
    },
    getComplianceReport: (id, month, year) => {
      return axios.get(`https://www.grcpulse.in/api/companyMasterProfile/monthly-compliance-report/${id ? id : "id"}`, { params: { month, year } })
    },
    createClientMasterData: (data) => {
      return axios.post(`https://www.grcpulse.in/api/ClientsMaterData/ClientMasterData`, data)
    },
     deleteMasterData: (id) => {
      return axios.delete(`https://www.grcpulse.in/api/ClientsMaterData/delete-masterdata/${id ? id : 'id'}`,);

    },
    getClientMasterData: (id) => {
      return axios.get(`https://www.grcpulse.in/api/ClientsMaterData/ClientMasterData/${id ? id : "id"}`)
    },
    updateClientMasterData: (data) => {
      return axios.put(`https://www.grcpulse.in/api/ClientsMaterData/updateClientMasterData`, data);
    },
    createEstablishmentMonthlyData: (data) => {
      return axios.post(`https://www.grcpulse.in/api/EstMonthlyData/createEstMonthlyData`, data);
    },
    getEstablishmentMonthlyData : (id,month,year,division) => {
      return axios.get(`https://www.grcpulse.in/api/EstMonthlyData/Get-EstMonthlyData/${id ? id : "id"}`,{params: {month,year,division}})
    },
    updateEstablishmentMonthlyData : (data) => {
      return axios.put(`https://www.grcpulse.in/api/EstMonthlyData/updateEstMonthlyData`,data)
    },
    getEstDetails: ( id , division ) => {
      return axios.get(`https://www.grcpulse.in/api/ClientsMaterData/Establishment-Details/${id ? id : "id"}`,{params: {division}} );
    },
    getEstYearly: ( id, year) => {
      return axios.get(`https://www.grcpulse.in/api/EstMonthlyData/get-yearly/${id ? id : "id"}`, { params: { year }} );
    },
    assessorToMail: (data) => {
      return axios.post(`https://www.grcpulse.in/api/EstMonthlyData/mailtoassessor`,data)
    },
    mailToAssessor: (data) => {
      return axios.post(`https://www.grcpulse.in/api/ClientsMaterData/mail-assessor`,data)
    }

  },

  assessor: {
    getEstablishment : (id,data) => {
      return axios.get(`https://www.grcpulse.in/api/Assessor/establishment-details/${id ? id :'id'}`,data);
    },
    getassessor: (id, data) => {
      return axios.get(`https://www.grcpulse.in/api/companyMasterProfile/getallasssessor/${id ? id : 'id'}`, data);
    },
    getAssessors: () => {
      return axios.get(`https://www.grcpulse.in/api/Assessor/allassessors`);
    },
    createAssessor: (data) => {
      return axios.post(`https://www.grcpulse.in/api/Assessor/create-assessor`, data);
    },
    findOne: (id, data) => {
      return axios.get(`https://www.grcpulse.in/api/Assessor/assessor-details/${id ? id : "id"}`, data);
    },
    editAssessor: (id, data) => {
      return axios.put(`https://www.grcpulse.in/api/Assessor/edit-assessor/${id ? id : 'id'}`, data);
    },
    dashboard: (id, month, year) => {
      return axios.get(`https://www.grcpulse.in/api/Assessor/vendorAvg/${id ? id : 'id'}`, { params: { month, year } })
    },
    fromAssessorMail : (data) => {
      return axios.post(`https://www.grcpulse.in/api/EstMonthlyData/mailtoestablishment`,data)
    },
    fromAssessorMasterdataMail : (data) => {
      return axios.post(`https://www.grcpulse.in/api/Assessor/Assess-mail`,data);
    },
    assessorMailToVendorMasterData : (data) => {
      return axios.post(`https://www.grcpulse.in/api/companyMasterData/mastermailtovendor`,data)
    },
    assessorMailToVendorMonthlyData : (data) => {
      return axios.post(`https://www.grcpulse.in/api/monthlydata/mailtovendor`,data)

    }

  },

  vendor: {
    createVendor: (data) => {
      return axios.post(`https://www.grcpulse.in/api/vendorMasterProfile/newVendorProfile`, data);
    },
    createVendorMonthlyData: (data) => {
      return axios.post(`https://www.grcpulse.in/api/monthlydata/createmonthlydata`, data);
    },
    findvendor: () => {
      return axios.get('https://www.grcpulse.in/api/vendorMasterProfile/findOne');
    },
    editVendor: (id, data) => {
      return axios.put(`https://www.grcpulse.in/api/Assessor/edit-vendor_details/${id ? id : "id"}`, data);
    },
    getVendors: (id) => {
      return axios.get(`https://www.grcpulse.in/api/Assessor/vendor's-details/${id ? id : "id"}`);
    },
    updateOne: (id, data) => {
      return axios.put(`https://www.grcpulse.in/api/vendorMasterProfile/updateOne/${id ? id : ":id"}`, data)
    },
    fetchVendorDetailsById: (id) => {
      return axios.get(`https://www.grcpulse.in/api/vendorMasterProfile/vendorDetails/${id ? id : ":id"}`);
    },
    getMonthlyData: (id, month, year) => {
      return axios.get(`https://www.grcpulse.in/api/monthlydata/getdata/${id ? id : ":id"}`, { params: { month, year } });
    },
    updateMonthlyData: (data) => {
      return axios.put(`https://www.grcpulse.in/api/monthlydata/update`, data);
    },
    deleteVendors: (id) => {
      return axios.put(`https://www.grcpulse.in/api/vendorMasterProfile/delete/${id ? id : ":id"}`);
    },
    activeVendors: (id) => {
      return axios.put(`https://www.grcpulse.in/api/vendorMasterProfile/activate/${id ? id : ":id"}`);
    },
    getDeactiveVendors: (id) => {
      return axios.get(`https://www.grcpulse.in/api/vendorMasterProfile/get-deactive-vendor/${id ? id : ":id"}`)
    },
    mailToAssessorFromVendorMasterData : (data) => {
      return axios.post(`https://www.grcpulse.in/api/companyMasterData/mastermailtoassessor`,data)
    },
      mailToAssessorFromVendorMonthlyData : (data) => {
      return axios.post(`https://www.grcpulse.in/api/monthlydata/mailtoassessor`,data)
    }
  },

  contactUs: {
    onContactUsApi: (data) => {
      return axios.post('https://www.grcpulse.in/api/webcontactus/contactus', data)
    }
  },

  common: {
    getAllStatesApi: () => {
      return axios.get(`https://www.grcpulse.in/api/states/getState`)
    },
    uploadFileApi: (formData, stateId, industryName) => {
      return axios.put(`https://www.grcpulse.in/api/minimum_wage/uploadfile/${stateId}/${industryName}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
    }
  },

  minimumWages: {
    getMinimumWagesAllStates: () => {
      return axios.get(`https://www.grcpulse.in/api/states/getState`);
    },

    getMinimumWagesById: (id, year) => {
      return axios.get(`https://www.grcpulse.in/api/minimum_wage/getminimumwate/${id}?year=${year}`);
    },

    createMinimumWages: (data) => {
      return axios.post(`https://www.grcpulse.in/api/minimum_wage/createMiniWage`, data)
    },
    getAllMinimumWagesApi: (year) => {
      return axios.get(`https://www.grcpulse.in/api/minimum_wage/yearlyMinimumwage/${year}`);
    },
    onDeleteWagesApi: (id) => {
      return axios.delete(`https://www.grcpulse.in/api/minimum_wage/delete/${id}`);
    },
    getMinimumWagesByStateYearIndustry: (StateId, year, industryType) => {
      return axios.get(`https://www.grcpulse.in/api/minimum_wage/minimum-wages`, {
        params: { StateId, year, industryType }
      });
    },
    onEditMinimumWage: (id, data) => {
      return axios.put(`https://www.grcpulse.in/api/minimum_wage/edit_MinimumWage/${id}`, data)
    },
    onGetIndustryTypesBasedOnState: (id) => {
      return axios.get(`https://www.grcpulse.in/api/industry/getindustry/${id}`)
    },
    onCreateIndustryType: (data) => {
      return axios.post('https://www.grcpulse.in/api/industry/create/', data)
    },
    onEditIndustryTypeApi: (id, data) => {
      return axios.put(`https://www.grcpulse.in/api/industry/editindustry/${id}`, data)
    },
    onDeleteIndutryTypeApi: (id) => {
      return axios.delete(`https://www.grcpulse.in/api/industry/delete/${id}`)
    }
  },

  Corporate: {
    CreateCorporate: (data) => {
      return axios.post('https://www.grcpulse.in/api/central/create-Corporate', data);
    },
    getCorporate: () => {
      return axios.get(`https://www.grcpulse.in/api/central/all_corporate`)
    },
    getClientByCorporateId: (id) => {
      return axios.get(`https://www.grcpulse.in/api/central/client/${id ? id : "id"}`)
    },
    updateCorporateDetails: (id, data) => {
      return axios.put(`https://www.grcpulse.in/api/central/clientEdit/${id ? id : 'id'}`, data)
    },
    getCoporateProfileDetails: (id) => {
      return axios.get(`https://www.grcpulse.in/api/central/getcorporate/${id ? id : 'id'}`)
    },
    updateCorporateProfile: (id, data) => {
      return axios.put(`https://www.grcpulse.in/api/central/clientEdit/${id ? id : 'id'}`, data)
    },
    avrgMonthlyComplianceClientWise: (id, year) => {
      return axios.get(`https://www.grcpulse.in/api/central/clientAvg/${id ? id : 'id'}`, { params: { year } })
    },
    employeesandVendorCount: (id) => {
      return axios.get(`https://www.grcpulse.in/api/central/noofemployes/${id ? id : 'id'}`);
    },
    getAllEstMonthlyreport: ( id, month, year, division ) => {
      return axios.get(`https://www.grcpulse.in/api/central/est-monthly-compliance-report/${id ? id : 'id'}`, { params: { month, year, division } })
    },
    establishmentMonthlyAvrg : (id,year,division) => {
      return axios.get(`https://www.grcpulse.in/api/central/establishmentMonthlyAvg/${id ? id : 'id'}`,{ params: { year , division} })
    },
     establishmentMasterAvrg : (id,division) => {
      return axios.get(`https://www.grcpulse.in/api/central/establishmentMasterAvg/${id ? id : 'id'}`,{ params: { division } })
    },
    getDivison : (id) => {
      return axios.get(`https://www.grcpulse.in/api/companyMasterProfile/getdivision/${id ? id : 'id'}`)
    }
  },

  Updates : {
    uploadNotification : (data) =>{
      return axios.post(`https://www.grcpulse.in/api/web-Notification/upload`, data);
    },
    getUploadedNotification : () => {
      return axios.get(`https://www.grcpulse.in/api/web-Notification/getUpdates`);
    },
    getAllUploadedNotifications: () => {
      return axios.get(`https://www.grcpulse.in/api/web-Notification/getallupdates`);
    },
    EditNotifications : (id , data) => {
      return axios.put(`https://www.grcpulse.in/api/web-Notification/edit-notification/${id}`, data);
    },
    deleteNotifications : (id) => {
      return axios.delete(`https://www.grcpulse.in/api/web-Notification/delete-notification/${id}`);
    }
  },

  HolidayList :{
    uploadHolidayList : (data) => {
      return axios.post(`https://www.grcpulse.in/api/holidaylist/Create-HolidayList`, data);
    },
    getHolidayListByStateAndYear : (State, year) => {
      return axios.get(`https://www.grcpulse.in/api/holidaylist/get-HL`, { params: { State, year } });
    },
    deleteHolidayList : (id) => {
      return axios.delete(`https://www.grcpulse.in/api/holidaylist/delete/${id}`);
    },
    editUploadedHolidayList : (id, data) => {
      return axios.put(`https://www.grcpulse.in/api/holidaylist/edit-Holidaylist/${id}`, data);
    },
    getOneYearListOfAllStates : (year) => {
       return axios.get(`https://www.grcpulse.in/api/holidaylist/get-yearly-list`, { params: { year } });
    },
    
  },

  ActsAndRules : {
    createActAndRules : (data) => {
      return axios.post(`https://www.grcpulse.in/api/ActsRules/Create`,data)
    },
    getAllActs : (page = 1, pageSize = 10) => {
      return axios.get(`https://www.grcpulse.in/api/ActsRules/GetAllAct?page=${page}&pageSize=${pageSize}`)
    },
    getAllRules : (page = 1, pageSize = 10) => {
      return axios.get(`https://www.grcpulse.in/api/ActsRules/GetAllRules?page=${page}&pageSize=${pageSize}`)
    },
    getActsByState : (state,page = 1, pageSize = 10) => {
      return axios.get(`https://www.grcpulse.in/api/ActsRules/GetActs`,{
      params: { State: state, page: page, pageSize: pageSize },
    })
    },
    getRulesByState : (state, page = 1, pageSize = 10) => {
      return axios.get(`https://www.grcpulse.in/api/ActsRules/GetRules`,{
      params: { State: state, page: page, pageSize: pageSize },
    })
    }, 
    deleteActAndRules : (id) => {
      return axios.delete(`https://www.grcpulse.in/api/ActsRules/delete/${id}`)
    },
    editActAndRules : (id,data) => {
      return axios.put(`https://www.grcpulse.in/api/ActsRules/edit/${id}`,data)
    }

  }

  
};

export default api;